import React from "react"
import svg from "../assets/double-arrow-down.png"
import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { zoomIn, slideIn, textVariant, textVariant2 } from "../utils/motion"
import { SectionWrapper } from "../hoc"
const Home = ({ index }) => {
  const [scrollPosition, setScrollPosition] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY
      setScrollPosition(position)
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])
  const getDynamicClass = () => {
    if (scrollPosition > 100) {
      return "hero-line-active"
    }
    return "hero-line"
  }

  return (
    <div className=" relative  w-full h-screen mx-auto">
      <section className="h-screen home-hero flex flex-col items-center justify-center py-24 ">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={zoomIn(index * 0.2, 0.55)}
          className="inline-flex py-24 flex-col items-center z-10"
        >
          <h1 className="inline-block uppercase font-leading font-normal leading-none home-hero-heading">
            <motion.span
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={textVariant2(0.5)}
              className="block"
            >
              Akruti
            </motion.span>
            <span className="block pt-4 md:pt-8">Concept Studio</span>
          </h1>
          <motion.h3
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={slideIn("left", "spring", 0.5, 0.65)}
            className="flex justify-between uppercase pt-4 md:pt-6 font-leading text-gold-100 home-hero-subtitle w-full"
          >
            <span className="letter font-montserrat">Subsidiary:</span>&nbsp;
            <span className="letter">Studio 32,</span>&nbsp;
            <span className="letter">Akruti Buildcon</span>
          </motion.h3>
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={textVariant(0.5)}
          className="px-auto inline-block mt-8 js-hero-arrow z-10"
        >
          <img src={svg} alt="double down arrow svg" width="40" />
        </motion.div>{" "}
      </section>{" "}
      <span
        className={`block w-[3px]  absolute bg-white ${getDynamicClass()} `}
        style={{ transform: "translate(-50%, -4.5rem)" }}
      ></span>
    </div>
  )
}

export default SectionWrapper(Home, "home")
